import { render, staticRenderFns } from "./OnlineResearch.vue?vue&type=template&id=0a20e791&scoped=true&"
import script from "./OnlineResearch.vue?vue&type=script&lang=js&"
export * from "./OnlineResearch.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/project-detail.css?vue&type=style&index=0&id=0a20e791&scoped=true&lang=css&"
import style1 from "./OnlineResearch.vue?vue&type=style&index=1&id=0a20e791&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a20e791",
  null
  
)

export default component.exports